import script from "./AppVersion.vue?vue&type=script&setup=true&lan=ts&lang=js"
export * from "./AppVersion.vue?vue&type=script&setup=true&lan=ts&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=7d735cbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d735cbb"]])

export default __exports__